import React, { useEffect, useState } from 'react';
import Logo from '../../assets/img/brand/logo-blue.png';
import { AppForm } from 'components/new_components/forms';
import { AppSubmitButton } from 'components/new_components/forms';
import { loginValidation } from 'views/auth/utils/authValidation';
import { AppFormInput } from 'components/new_components/forms';
import { labelStyles, inputStyles } from './components/styles';
import { EmailIcon, PasswordIcon } from './components/Icons';
import { LoginBusinessUser } from 'store/actions/authActions';
import { setAuthFlag } from 'utils';
import { LogoutUser } from 'store/actions/authActions';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

export default function Login() {
    const dispatch = useDispatch();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [passwordIsVisible, setPasswordIsVisibile] = useState(false);

    const handleSubmit = async (values) => {
        setLoading(true);
        const res = await dispatch(LoginBusinessUser(values));
        setLoading(false);
        if (res?.success) {
            setAuthFlag();
            setTimeout(() => {
                history.push('/business-profile/profile');
            }, 1000);
        } else {
            toast.error(
                "Couldn't validate your credentials" ||
                    res?.message ||
                    "Something went wrong, we couldn't validate your credentials. Try again!"
            );
        }
    };

    const logout = async () => {
        await LogoutUser();
        dispatch({ type: 'CLEAR_DATA' });
    };

    const clearCacheData = () => {
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        }
    };

    useEffect(() => {
        clearCacheData();
        logout();
    }, []);
    return (
        <div className="bg-white h-[100dvh] p-3 max-w-[500px] mx-auto">
            <div>
                <img src={Logo} className="w-[150px] h-auto" />
                <h4 className="text-gray-600 text-xs -mt-1.5 pl-1.5">Digital Business card</h4>
            </div>
            <div className="flex flex-col mt-20 px-1">
                <div className="block mb-4">
                    <h2 className="font-bold text-gray-700 text-3xl">Login</h2>
                    <p className="text-sm">Welcome back!. Login to your e-business card panel</p>
                </div>
                <AppForm
                    initialValues={{ email: '', password: '' }}
                    onSubmit={handleSubmit}
                    validate={(values) => loginValidation(values)}
                >
                    <div className="flex flex-col gap-1">
                        <div className="">
                            <AppFormInput
                                type="email"
                                label={'Email'}
                                name="email"
                                large
                                startAdornment={
                                    <div className=" pr-2">
                                        <EmailIcon />
                                    </div>
                                }
                                labelStyle={labelStyles}
                                sx={inputStyles}
                            />
                        </div>
                        <div className="">
                            <AppFormInput
                                type={passwordIsVisible ? 'text' : 'password'}
                                label={'Password'}
                                placeholder="••••••••"
                                name="password"
                                large
                                startAdornment={
                                    <div className=" pr-2">
                                        <PasswordIcon />
                                    </div>
                                }
                                endAdornment={
                                    <div
                                        className=" pl-2 cursor-pointer"
                                        onClick={() => setPasswordIsVisibile((prev) => !prev)}
                                    >
                                        {passwordIsVisible ? (
                                            <EyeInvisibleOutlined className="text-gray-600 text-xl" />
                                        ) : (
                                            <EyeOutlined className="text-gray-600 text-xl" />
                                        )}
                                    </div>
                                }
                                labelStyle={labelStyles}
                                sx={inputStyles}
                            />
                        </div>
                    </div>
                    <AppSubmitButton
                        text={'Login'}
                        variant="contained"
                        color="primary"
                        loadingPosition="center"
                        sx={{
                            width: '100%',
                            mt: 3,
                            padding: '12px 8px 12px 8px',
                            backgroundColor: '#002c72',
                            borderRadius: '8px',
                        }}
                        loading={loading}
                    />
                </AppForm>
            </div>
        </div>
    );
}
